import React, { useState } from 'react';
import axios from 'axios';
import logo from '../../assets/logo.png';
import { baseUrl } from '../../lib/constants';
import { useError } from "../../state/error";
import { Link } from "react-router-dom";
const ForgotPass = () => {
  const { setIsError } = useError();
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    setIsLoading(true);

    axios.post(`${baseUrl}/admins/forgot`, {
      email: email
    })
    .then((response) => {
      setIsLoading(false);

      if (response.data.status) {
        setIsError(response.data.message, 'success');
        setEmail('');
      } else {
        setIsError(response.data.message || "Something went wrong");
      }
    })
    .catch((error) => {
      setIsLoading(false);
      setIsError(error?.response?.data?.message || "Server error");
    });
  };

  return (
    <div className="page">
      <div className="page-single">
        <div className="container">
          <div className="row">
            <div className="col col-login mx-auto">
              
              <div className="text-center mb-6">
                <img src={logo} className="h-9" alt="" />
              </div>

              <form className="card" onSubmit={handleSubmit}>
                <div className="card-body p-6">

                  <div className="card-title">Forgot password</div>

                  <p className="text-muted">
                    Enter your email address and we will send you a reset link.
                  </p>

                  <div className="form-group">
                    <label className="form-label">Email address</label>

                    <input
                      type="email"
                      className="form-control"
                      placeholder="Enter email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>

                  <div className="form-footer">
                    <button
                      type="submit"
                      className={`btn btn-primary btn-block ${isLoading && 'btn-loading'}`}
                      disabled={isLoading}
                    >
                      Send reset link
                    </button>
                  </div>


                  <div className="text-center mt-3">
                    <Link to="/login">Back to login</Link>
                  </div>
                </div>
                
              </form>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPass;